import dynamic from 'next/dynamic';

const Hero = dynamic(() => import('./Hero'), { ssr: true });
const KnowWho = dynamic(() => import('./KnowWho'), { ssr: true });
const HowItWorks = dynamic(() => import('./HowItWorks'), { ssr: true });
const Comparison = dynamic(() => import('./Comparison'), { ssr: true });
const FAQ = dynamic(() => import('./FAQ'), { ssr: true });
const Testimonials = dynamic(() => import('./Testimonials'), { ssr: true });
const BlogContent = dynamic(() => import('./BlogContent/index'), { ssr: true });
const Pricing = dynamic(() => import('./Pricing'), { ssr: true });
const ExploreMoreToolsSection = dynamic(() => import('./ExploreMoreToolsSection'), { ssr: true });
const Index = ({ ...props }) => {
  return (
    <div className="max-w-[1200px] mx-auto m-auto sm:pl-4 sm:pr-4 ">
      <Hero />
      <KnowWho />
      <HowItWorks />
      <Comparison />
      <Pricing />
      <FAQ />
      <Testimonials />
      {props.data?.contentInfo['section-top-blog'].title && (
        <BlogContent title={props.data?.contentInfo['section-top-blog'].title} data={props.data?.topBlogList} />
      )}
      {props.data?.contentInfo['section-blog'].title && (
        <BlogContent title={props.data?.contentInfo['section-blog'].title} data={props.data?.blogList} />
      )}
      <ExploreMoreToolsSection />
    </div>
  );
};

export default Index;
